import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("madubau_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [discount, setDiscount] = useState(() => {
    try { return JSON.parse(localStorage.getItem("madubau_discount") || "null"); } catch { return null; }
  });

  useEffect(() => { localStorage.setItem("madubau_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("madubau_discount", JSON.stringify(discount)); }, [discount]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product.id === product.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [...prev, { product, qty }];
    });
    setOpen(true);
  };
  const remove = (id) => setItems((p) => p.filter((i) => i.product.id !== id));
  const setQty = (id, qty) => setItems((p) => p.map((i) => i.product.id === id ? { ...i, qty: Math.max(1, Math.min(99, qty)) } : i));
  const clear = () => { setItems([]); setDiscount(null); };
  const applyDiscount = (d) => setDiscount(d);
  const clearDiscount = () => setDiscount(null);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.product.price_eur, 0);
  const discountAmount = discount ? Math.min(discount.amount_off_eur || 0, subtotal) : 0;
  const total = Math.max(0, subtotal - discountAmount);

  return <CartCtx.Provider value={{ items, add, remove, setQty, clear, open, setOpen, count, subtotal, discount, applyDiscount, clearDiscount, discountAmount, total }}>{children}</CartCtx.Provider>;
}
export const useCart = () => useContext(CartCtx);
